import styled from 'styled-components';

export const Container = styled.div`

  .button-style {
    font-size: 12px;
  color: #999999;
  background-color: #eaeaea;
  padding: 0;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 10px 20px;
  cursor: pointer;
  font-family: 'Roboto Condensed', sans-serif;
  display: flex;
  align-items: center;
  border-radius: 5px;
  outline: none;
  border: none;
  border-radius: 5px;

  &:hover {
      background-color: #eaeaea
  }


`;
